/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CloudUpload16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M7.5 2c1.563 0 2.94.797 3.747 2.007a5 5 0 01-.03 9.988L11 14h-1a1 1 0 01-1-1v-3h1.499a.5.5 0 00.412-.784L8.354 6.147a.499.499 0 00-.708 0l-2.5 3A.5.5 0 005.5 10H7l-.001 3.017-.006.1A1 1 0 016 14H4a4 4 0 01-.984-7.878A4.5 4.5 0 017.5 2z"
        />
    </AccessibleSVG>
);

export default CloudUpload16;
